var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-loader',{on:{"success":_vm.onLoadSuccess,"error":_vm.onLoadError}})
}
var staticRenderFns = []

export { render, staticRenderFns }